var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScribbleZigzagPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.442 3.03648C10.442 3.03648 5.76598 5.22255 3.11233 8.88236",
    stroke: "#FC916B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74687 9.59788C2.7096 9.76543 2.70983 9.93911 2.74754 10.106C2.84733 10.5318 3.19945 10.9115 4.30274 10.4264C5.40604 9.94134 10.8212 6.56645 19.6775 3.6301C19.8428 3.57159 20.0226 3.57351 20.1859 3.63553C20.3492 3.69755 20.4856 3.81578 20.5717 3.96977C20.6578 4.12377 20.6881 4.30386 20.6573 4.47893C20.6266 4.65399 20.5367 4.81304 20.4033 4.92857C19.2389 5.98785 17.7614 7.33792 16.1652 8.79389",
    stroke: "#FC916B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "70.55 2.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 9.06089C13.4215 11.3205 10.7309 13.7867 8.46746 15.9019C5.16356 18.9831 4.55085 19.5129 5.21949 20.9753C6.03233 22.7475 9.81461 20.8412 9.81461 20.8412C9.81461 20.8412 19.136 16.7154 27.9908 13.6237",
    stroke: "#FC916B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "35.27 2.12 70.55 2.12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.351 13.4894C31.3019 12.4305 34.308 11.5409 37.3549 10.8248",
    stroke: "#FC916B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribbleZigzagPrice);
export default __webpack_public_path__ + "static/media/scribble-zigzag-price.7936a8dbc92917ded867d2e5d0482d7b.svg";
export { ForwardRef as ReactComponent };